import React, { Fragment } from 'react';
import { Dialog } from './../../common/dialog';
import { getCanvasFrontDataUrl, getCanvasBackDataUrl } from './../CanvasActions';

const ConfirmationModal = (props) => {
    const hideHandler = () => {
        props.setAddToCartOrderType(null);
        props.setAddToCartType(null);
        props.hideConfirmationModal();
    };

    const acceptHandler = () => {
        props.addToCart(props.addToCartOrderType, props.history, props.addToCartType);
        props.hideConfirmationModal();
    };

    let ratio = 1;
    if ([
        'p1t8', 'p1t9', 'p1t11', 'p1t14', 'p1t16', 'p1t15', 'p9t1', 'p9t2', 'p9t3', 'p9t4', 'p9t5', 'p9t6', 'p9t7', 'p9t8', 'p9t9', 'p9t10', 'p9t11', 'p9t12', 'p9t13', 
        'p9t14', 'p9t15', 'p9t16', 'p9t17', 'p9t18', 'p9t19', 'p9t20', 'p9t21', 'p9t22', 'p9t23'
    ].includes(props.templateCode)) {
        ratio = 0.95;
    } if (
        [
            'p2t1', 'p2t3', 'p3t1', 'p3t2', 'p3t3', 'p3t4', 'p3t5', 'p3t6', 'p10t1', 'p10t2', 'p10t3', 'p10t4', 'p10t5', 'p10t6', 'p10t7',
            'p10t8', 'p10t9', 'p10t10', 'p11t1', 'p11t2', 'p11t3', 'p11t4', 'p11t5', 'p11t6', 'p11t7', 'p11t8', 'p11t9', 'p11t10', 'p11t11', 'p11t12',
            'p11t13', 'p11t14', 'p11t15', 'p11t16', 'p11t17', 'p11t18', 'p11t19', 'p11t20', 'p11t21', 'p11t22', 'p11t23', 'p11t24', 'p11t25', 'p20t1', 'p20t2', 'p20t3', 'p20t4',
            'p20t5', 'p20t6', 'p20t7', 'p20t8', 'p20t9', 'p21t1', 'p21t2'
        ].includes(props.templateCode)
    ) {
        ratio = 1.5;
    }

    let backContent = null;
    if (!['p1t10', 'p2t1', 'p2t3', 'p2t2', 'p2t4', 'p3t1', 'p3t2', 'p3t3', 'p3t4', 'p3t5', 'p3t6', 'p4t1', 'p4t3', 'p10t1', 'p10t2', 'p10t3',
        'p10t4', 'p10t5', 'p10t6', 'p10t7', 'p10t8', 'p10t9', 'p10t10', 'p11t1', 'p11t2', 'p11t3', 'p11t4', 'p11t5', 'p11t6', 'p11t7', 'p11t8', 'p11t9', 
        'p11t10', 'p11t11', 'p11t12', 'p11t13', 'p11t14', 'p11t15', 'p11t16', 'p11t17', 'p11t18', 'p11t19', 'p11t20', 'p11t21', 'p11t22', 'p11t23', 'p11t24', 'p11t25', 'p12t1',
        'p12t2', 'p12t3', 'p12t4', 'p12t5', 'p12t6', 'p12t7', 'p12t8', 'p12t9', 'p12t10', 'p17t1', 'p17t2', 'p17t3', 'p17t4', 'p17t5', 'p18t1', 'p18t3', 'p18t4',
        'p19t1', 'p20t1', 'p20t2', 'p20t3', 'p20t4', 'p20t5', 'p20t6', 'p20t7', 'p20t8', 'p20t9', 'p21t1', 'p21t2'].includes(props.templateCode)
    ) {
        backContent = (
            <Fragment>
                <h2>Back Side</h2>
                <div className="img-container"><img src={getCanvasBackDataUrl(ratio)} alt="Back" /></div>
            </Fragment>
        );
    }

    let actions = [
        <div className="disclaimer">By accepting this design. You are responsible for its content.</div>,
        <button key="cancel-button" className="btn btn-light btn-sm action-button-cancel" onClick={hideHandler}>Cancel</button>,
        <button key="confirm-button" className="btn btn-light btn-sm action-button" onClick={acceptHandler}>I Accept</button>
    ];
    return (
        <Dialog
            name="confirmation-modal"
            modal={false}
            actions={actions}
            contentStyle={{ width: 800 }}
            bodyStyle={{ overflow: 'initial' }}
            className="confirmation-dialog"
        >
            <div className="confirmation-modal-container">
                <h1>Confirm your design</h1>
                <p className="notice">
                    Please check for spelling, wording, punctuation and arrangement. After a layout has been <b>approved by you</b>,
                    any production errors will be quickly and willingly corrected, but the correction will be at <b>your expense</b>.
                </p>
                <h2>Front Side</h2>
                <div className="img-container"><img src={getCanvasFrontDataUrl(ratio)} alt="Front" /></div>
                {backContent}

            </div>
        </Dialog>
    );
};

export default ConfirmationModal;
